module.exports = __webpack_public_path__ + "assets/ic_weather05.b81aa86d.svg";